<template>
  <div class="teamWarp">
    <div class="itemCard" v-if="showAddNewGroup">
      <div class="lineContent">
        <div class="name">团队名称</div>
        <el-input v-model="team.orgName" placeholder="请输入团队名称"></el-input>
      </div>
      <div class="lineContent">
        <div class="name">团队负责人</div>
        <el-input v-model="team.personName" placeholder="请输入团队负责人" :disabled="team.disabled" :maxlength="16"></el-input>
      </div>
      <div class="lineContent">
        <div class="name">证件号码</div>
        <el-input v-model="team.cardNum" placeholder="请输入证件号码" :disabled="team.disabled && team.cardType == 1"></el-input>
      </div>
      <div class="lineContent">
        <div class="name">联系电话</div>
        <el-input v-model="team.phone" placeholder="请输入联系电话" :disabled="team.disabled"></el-input>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      
    };
  },

  props: ['team', 'showAddNewGroup', 'museumCode'],

  methods: {
  },

  created() {
    this.actionUrl = Glob.baseUrl + '/api/file/upload/'
  },

  computed: {
  
  }
}
</script>

<style scoped lang="scss">
  .teamWarp{
    .buttonLeft{
      margin-left: -1rem;
    }
    .lastLine{
      margin-top: 0.2rem;
    }
  }
</style>
